import styled from 'styled-components';
import { baseTheme } from '../../global/styles/theme';

export const LoyaltyPageContainer = styled('div')`
  width: 80%;
  margin: 0 auto;
  min-height: calc(100vh - 200px);
  height: calc(100vh - 200px);
  position: relative;
  border: 1px solid ${baseTheme.colors.mainLightBlue};
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 550px) {
    padding: 0;
  }
`;

export const PharmacyInnerInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 20%;
  padding: 16px;
  border-bottom: 1px solid ${baseTheme.colors.mainLightBlue};
  font-weight: 700;
  font-size: 20px;
  background-color: ${baseTheme.colors.white};

  .client-info {
    display: flex;
    align-items: center;
    gap: 15px;
    input {
      width: 200px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid ${baseTheme.colors.mainLightBlue};
      padding: 0 10px;
      font-size: 22px;
      color: ${baseTheme.colors.primary};
    }
    .error-phone-label {
      font-weight: 500;
      color: ${baseTheme.colors.error};
      font-size: 18px;
    }
  }
`;

export const ActiveReceipt = styled('div')`
  padding: 16px;
  border-bottom: 1px solid ${baseTheme.colors.mainLightBlue};
  display: flex;
  flex-direction: column;
  height: 60%;

  .active-receipt-top {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .left-block {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .back-to-reciepts {
        display: flex;
        align-items: center;
        gap: 5px;
        width: fit-content;
        cursor: pointer;
        box-shadow: 0px 0px 10px black;
        padding: 5px 10px;
        border-radius: 15px;

        &:hover {
          color: ${baseTheme.colors.mainLightBlue};
          font-size: 14px;
        }

        &: hover img {
          height: 13px;
          width: 13px;
        }

        & img {
          transform: rotate(90deg);
          height: 15px;
          width: 15px;
        }
      }

      .last-update {
        display: flex;
        align-items: center;
        gap: 5px;
      }

      .active-receipt-title {
        font-weight: 500;
        color: ${baseTheme.colors.mainLightBlue};
      }
    }
  }

  .active-receipt-error {
    font-weight: 500;
    color: ${baseTheme.colors.error};
    font-size: 18px;
    margin-top: 10px;
  }
`;

export const ApplyBlock = styled('div')`
  height: 10%;
  padding: 16px;
  display: flex;
  justify-content: flex-end;
`;

export const Footer = styled('div')`
  height: 10%;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 10px;

  span {
    color: ${baseTheme.colors.mainLightBlue};
  }
`;

export const Balance = styled.div<{ user?: boolean }>`
  background-color: ${({ user }) =>
    user ? baseTheme.colors.focus : baseTheme.colors.mainLightBlue};
  border-radius: 4px;
  width: fit-content;
  padding: 4px 12px;
  color: ${baseTheme.colors.white};
  font-weight: 700;
  font-size: 16px;
`;

export const PriceBlock = styled.div<{ marginTop?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${({ marginTop }) => (marginTop ? '10px' : '0')};
  gap: 30px;
  font-weight: 700;
  font-size: 16px;
`;

export const Price = styled.div<{ green?: boolean }>`
  width: fit-content;
  font-weight: 700;
  font-size: 16px;
  background-color: ${({ green }) =>
    green ? baseTheme.colors.focusLight : 'transparent'};
`;
